/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DownloadAdminProblemReportAttachmentParams,
  DownloadOwnProblemReportAttachmentParams,
  ListAdminProblemReportsParams,
  ListOwnProblemReportsParams,
  ListProblemReportAssigneesParams,
  ListProblemReportNotificationsParams,
  Problem,
  ProblemReportAdminPage,
  ProblemReportAdminRead,
  ProblemReportAssigneePage,
  ProblemReportAttachmentRead,
  ProblemReportCapabilities,
  ProblemReportCommand,
  ProblemReportCommandReceipt,
  ProblemReportConfirmation,
  ProblemReportCreate,
  ProblemReportDownloadGrant,
  ProblemReportNotificationPage,
  ProblemReportNotificationTarget,
  ProblemReportPage,
  ProblemReportRead,
  ProblemReportUploadConfirm,
  ProblemReportUploadGrant,
  ProblemReportUploadRequest
} from '../model';

import { orvalClient } from '../../orval-client';




export type createProblemReportResponse200 = {
  data: ProblemReportRead
  status: 200
}

export type createProblemReportResponse201 = {
  data: ProblemReportRead
  status: 201
}

export type createProblemReportResponse401 = {
  data: Problem
  status: 401
}

export type createProblemReportResponse403 = {
  data: Problem
  status: 403
}

export type createProblemReportResponse404 = {
  data: Problem
  status: 404
}

export type createProblemReportResponse409 = {
  data: Problem
  status: 409
}

export type createProblemReportResponse422 = {
  data: Problem
  status: 422
}

export type createProblemReportResponse429 = {
  data: Problem
  status: 429
}

export type createProblemReportResponse503 = {
  data: Problem
  status: 503
}

export type createProblemReportResponseSuccess = (createProblemReportResponse200 | createProblemReportResponse201) & {
  headers: Headers;
};
export type createProblemReportResponseError = (createProblemReportResponse401 | createProblemReportResponse403 | createProblemReportResponse404 | createProblemReportResponse409 | createProblemReportResponse422 | createProblemReportResponse429 | createProblemReportResponse503) & {
  headers: Headers;
};

export type createProblemReportResponse = (createProblemReportResponseSuccess | createProblemReportResponseError)

export const getCreateProblemReportUrl = () => {




  return `/api/v1/problem-reports`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Create a private report; identical replay returns 200 before quota.
 */
export const createProblemReport = async (problemReportCreate: ProblemReportCreate, options?: RequestInit): Promise<createProblemReportResponse> => {

  return orvalClient<createProblemReportResponse>(getCreateProblemReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportCreate)
  }
);}




export const getCreateProblemReportMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext> => {

const mutationKey = ['createProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProblemReport>>, {data: ProblemReportCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProblemReport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof createProblemReport>>>
    export type CreateProblemReportMutationBody = ProblemReportCreate
    export type CreateProblemReportMutationError = Problem

    /**
 * @summary Create a private report; identical replay returns 200 before quota.
 */
export const useCreateProblemReport = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProblemReport>>,
        TError,
        {data: ProblemReportCreate},
        TContext
      > => {
      return useMutation(getCreateProblemReportMutationOptions(options), queryClient);
    }
    export type listOwnProblemReportsResponse200 = {
  data: ProblemReportPage
  status: 200
}

export type listOwnProblemReportsResponse401 = {
  data: Problem
  status: 401
}

export type listOwnProblemReportsResponse403 = {
  data: Problem
  status: 403
}

export type listOwnProblemReportsResponse404 = {
  data: Problem
  status: 404
}

export type listOwnProblemReportsResponse409 = {
  data: Problem
  status: 409
}

export type listOwnProblemReportsResponse422 = {
  data: Problem
  status: 422
}

export type listOwnProblemReportsResponse429 = {
  data: Problem
  status: 429
}

export type listOwnProblemReportsResponse503 = {
  data: Problem
  status: 503
}

export type listOwnProblemReportsResponseSuccess = (listOwnProblemReportsResponse200) & {
  headers: Headers;
};
export type listOwnProblemReportsResponseError = (listOwnProblemReportsResponse401 | listOwnProblemReportsResponse403 | listOwnProblemReportsResponse404 | listOwnProblemReportsResponse409 | listOwnProblemReportsResponse422 | listOwnProblemReportsResponse429 | listOwnProblemReportsResponse503) & {
  headers: Headers;
};

export type listOwnProblemReportsResponse = (listOwnProblemReportsResponseSuccess | listOwnProblemReportsResponseError)

export const getListOwnProblemReportsUrl = (params?: ListOwnProblemReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports?${stringifiedParams}` : `/api/v1/problem-reports`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary List only reports authored by the active user in the canonical organization.
 */
export const listOwnProblemReports = async (params?: ListOwnProblemReportsParams, options?: RequestInit): Promise<listOwnProblemReportsResponse> => {

  return orvalClient<listOwnProblemReportsResponse>(getListOwnProblemReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnProblemReportsQueryKey = (params?: ListOwnProblemReportsParams,) => {
    return [
    `/api/v1/problem-reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnProblemReportsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = Problem>(params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnProblemReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnProblemReports>>> = ({ signal }) => listOwnProblemReports(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnProblemReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnProblemReports>>>
export type ListOwnProblemReportsQueryError = Problem


export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = Problem>(
 params: undefined |  ListOwnProblemReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listOwnProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = Problem>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listOwnProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = Problem>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List only reports authored by the active user in the canonical organization.
 */

export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = Problem>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnProblemReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getOwnProblemReportResponse200 = {
  data: ProblemReportRead
  status: 200
}

export type getOwnProblemReportResponse401 = {
  data: Problem
  status: 401
}

export type getOwnProblemReportResponse403 = {
  data: Problem
  status: 403
}

export type getOwnProblemReportResponse404 = {
  data: Problem
  status: 404
}

export type getOwnProblemReportResponse409 = {
  data: Problem
  status: 409
}

export type getOwnProblemReportResponse422 = {
  data: Problem
  status: 422
}

export type getOwnProblemReportResponse429 = {
  data: Problem
  status: 429
}

export type getOwnProblemReportResponse503 = {
  data: Problem
  status: 503
}

export type getOwnProblemReportResponseSuccess = (getOwnProblemReportResponse200) & {
  headers: Headers;
};
export type getOwnProblemReportResponseError = (getOwnProblemReportResponse401 | getOwnProblemReportResponse403 | getOwnProblemReportResponse404 | getOwnProblemReportResponse409 | getOwnProblemReportResponse422 | getOwnProblemReportResponse429 | getOwnProblemReportResponse503) & {
  headers: Headers;
};

export type getOwnProblemReportResponse = (getOwnProblemReportResponseSuccess | getOwnProblemReportResponseError)

export const getGetOwnProblemReportUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Own report and public history.
 */
export const getOwnProblemReport = async (id: string, options?: RequestInit): Promise<getOwnProblemReportResponse> => {

  return orvalClient<getOwnProblemReportResponse>(getGetOwnProblemReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnProblemReportQueryKey = (id: string,) => {
    return [
    `/api/v1/problem-reports/${id}`
    ] as const;
    }


export const getGetOwnProblemReportQueryOptions = <TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = Problem>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnProblemReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnProblemReport>>> = ({ signal }) => getOwnProblemReport(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnProblemReportQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnProblemReport>>>
export type GetOwnProblemReportQueryError = Problem


export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = Problem>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Own report and public history.
 */

export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnProblemReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type confirmProblemReportResponse200 = {
  data: ProblemReportCommandReceipt
  status: 200
}

export type confirmProblemReportResponse401 = {
  data: Problem
  status: 401
}

export type confirmProblemReportResponse403 = {
  data: Problem
  status: 403
}

export type confirmProblemReportResponse404 = {
  data: Problem
  status: 404
}

export type confirmProblemReportResponse409 = {
  data: Problem
  status: 409
}

export type confirmProblemReportResponse422 = {
  data: Problem
  status: 422
}

export type confirmProblemReportResponse429 = {
  data: Problem
  status: 429
}

export type confirmProblemReportResponse503 = {
  data: Problem
  status: 503
}

export type confirmProblemReportResponseSuccess = (confirmProblemReportResponse200) & {
  headers: Headers;
};
export type confirmProblemReportResponseError = (confirmProblemReportResponse401 | confirmProblemReportResponse403 | confirmProblemReportResponse404 | confirmProblemReportResponse409 | confirmProblemReportResponse422 | confirmProblemReportResponse429 | confirmProblemReportResponse503) & {
  headers: Headers;
};

export type confirmProblemReportResponse = (confirmProblemReportResponseSuccess | confirmProblemReportResponseError)

export const getConfirmProblemReportUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/confirmation`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Confirm fixed or reopen with explanation and expected revision.
 */
export const confirmProblemReport = async (id: string,
    problemReportConfirmation: ProblemReportConfirmation, options?: RequestInit): Promise<confirmProblemReportResponse> => {

  return orvalClient<confirmProblemReportResponse>(getConfirmProblemReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportConfirmation)
  }
);}




export const getConfirmProblemReportMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext> => {

const mutationKey = ['confirmProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmProblemReport>>, {id: string;data: ProblemReportConfirmation}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmProblemReport(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof confirmProblemReport>>>
    export type ConfirmProblemReportMutationBody = ProblemReportConfirmation
    export type ConfirmProblemReportMutationError = Problem

    /**
 * @summary Confirm fixed or reopen with explanation and expected revision.
 */
export const useConfirmProblemReport = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmProblemReport>>,
        TError,
        {id: string;data: ProblemReportConfirmation},
        TContext
      > => {
      return useMutation(getConfirmProblemReportMutationOptions(options), queryClient);
    }
    export type reserveProblemReportAttachmentResponse200 = {
  data: ProblemReportUploadGrant
  status: 200
}

export type reserveProblemReportAttachmentResponse201 = {
  data: ProblemReportUploadGrant
  status: 201
}

export type reserveProblemReportAttachmentResponse401 = {
  data: Problem
  status: 401
}

export type reserveProblemReportAttachmentResponse403 = {
  data: Problem
  status: 403
}

export type reserveProblemReportAttachmentResponse404 = {
  data: Problem
  status: 404
}

export type reserveProblemReportAttachmentResponse409 = {
  data: Problem
  status: 409
}

export type reserveProblemReportAttachmentResponse413 = {
  data: Problem
  status: 413
}

export type reserveProblemReportAttachmentResponse415 = {
  data: Problem
  status: 415
}

export type reserveProblemReportAttachmentResponse422 = {
  data: Problem
  status: 422
}

export type reserveProblemReportAttachmentResponse429 = {
  data: Problem
  status: 429
}

export type reserveProblemReportAttachmentResponse503 = {
  data: Problem
  status: 503
}

export type reserveProblemReportAttachmentResponseSuccess = (reserveProblemReportAttachmentResponse200 | reserveProblemReportAttachmentResponse201) & {
  headers: Headers;
};
export type reserveProblemReportAttachmentResponseError = (reserveProblemReportAttachmentResponse401 | reserveProblemReportAttachmentResponse403 | reserveProblemReportAttachmentResponse404 | reserveProblemReportAttachmentResponse409 | reserveProblemReportAttachmentResponse413 | reserveProblemReportAttachmentResponse415 | reserveProblemReportAttachmentResponse422 | reserveProblemReportAttachmentResponse429 | reserveProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type reserveProblemReportAttachmentResponse = (reserveProblemReportAttachmentResponseSuccess | reserveProblemReportAttachmentResponseError)

export const getReserveProblemReportAttachmentUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/attachments/upload`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Reserve a private image upload; identical retry returns 200.
 */
export const reserveProblemReportAttachment = async (id: string,
    problemReportUploadRequest: ProblemReportUploadRequest, options?: RequestInit): Promise<reserveProblemReportAttachmentResponse> => {

  return orvalClient<reserveProblemReportAttachmentResponse>(getReserveProblemReportAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportUploadRequest)
  }
);}




export const getReserveProblemReportAttachmentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext> => {

const mutationKey = ['reserveProblemReportAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, {id: string;data: ProblemReportUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  reserveProblemReportAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReserveProblemReportAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof reserveProblemReportAttachment>>>
    export type ReserveProblemReportAttachmentMutationBody = ProblemReportUploadRequest
    export type ReserveProblemReportAttachmentMutationError = Problem

    /**
 * @summary Reserve a private image upload; identical retry returns 200.
 */
export const useReserveProblemReportAttachment = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reserveProblemReportAttachment>>,
        TError,
        {id: string;data: ProblemReportUploadRequest},
        TContext
      > => {
      return useMutation(getReserveProblemReportAttachmentMutationOptions(options), queryClient);
    }
    export type confirmProblemReportAttachmentResponse200 = {
  data: ProblemReportAttachmentRead
  status: 200
}

export type confirmProblemReportAttachmentResponse201 = {
  data: ProblemReportAttachmentRead
  status: 201
}

export type confirmProblemReportAttachmentResponse401 = {
  data: Problem
  status: 401
}

export type confirmProblemReportAttachmentResponse403 = {
  data: Problem
  status: 403
}

export type confirmProblemReportAttachmentResponse404 = {
  data: Problem
  status: 404
}

export type confirmProblemReportAttachmentResponse409 = {
  data: Problem
  status: 409
}

export type confirmProblemReportAttachmentResponse413 = {
  data: Problem
  status: 413
}

export type confirmProblemReportAttachmentResponse415 = {
  data: Problem
  status: 415
}

export type confirmProblemReportAttachmentResponse422 = {
  data: Problem
  status: 422
}

export type confirmProblemReportAttachmentResponse429 = {
  data: Problem
  status: 429
}

export type confirmProblemReportAttachmentResponse503 = {
  data: Problem
  status: 503
}

export type confirmProblemReportAttachmentResponseSuccess = (confirmProblemReportAttachmentResponse200 | confirmProblemReportAttachmentResponse201) & {
  headers: Headers;
};
export type confirmProblemReportAttachmentResponseError = (confirmProblemReportAttachmentResponse401 | confirmProblemReportAttachmentResponse403 | confirmProblemReportAttachmentResponse404 | confirmProblemReportAttachmentResponse409 | confirmProblemReportAttachmentResponse413 | confirmProblemReportAttachmentResponse415 | confirmProblemReportAttachmentResponse422 | confirmProblemReportAttachmentResponse429 | confirmProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type confirmProblemReportAttachmentResponse = (confirmProblemReportAttachmentResponseSuccess | confirmProblemReportAttachmentResponseError)

export const getConfirmProblemReportAttachmentUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/attachments/confirm`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Confirm validated image; identical replay returns 200.
 */
export const confirmProblemReportAttachment = async (id: string,
    problemReportUploadConfirm: ProblemReportUploadConfirm, options?: RequestInit): Promise<confirmProblemReportAttachmentResponse> => {

  return orvalClient<confirmProblemReportAttachmentResponse>(getConfirmProblemReportAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportUploadConfirm)
  }
);}




export const getConfirmProblemReportAttachmentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext> => {

const mutationKey = ['confirmProblemReportAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, {id: string;data: ProblemReportUploadConfirm}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmProblemReportAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmProblemReportAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof confirmProblemReportAttachment>>>
    export type ConfirmProblemReportAttachmentMutationBody = ProblemReportUploadConfirm
    export type ConfirmProblemReportAttachmentMutationError = Problem

    /**
 * @summary Confirm validated image; identical replay returns 200.
 */
export const useConfirmProblemReportAttachment = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmProblemReportAttachment>>,
        TError,
        {id: string;data: ProblemReportUploadConfirm},
        TContext
      > => {
      return useMutation(getConfirmProblemReportAttachmentMutationOptions(options), queryClient);
    }
    export type downloadOwnProblemReportAttachmentResponse200 = {
  data: ProblemReportDownloadGrant
  status: 200
}

export type downloadOwnProblemReportAttachmentResponse401 = {
  data: Problem
  status: 401
}

export type downloadOwnProblemReportAttachmentResponse403 = {
  data: Problem
  status: 403
}

export type downloadOwnProblemReportAttachmentResponse404 = {
  data: Problem
  status: 404
}

export type downloadOwnProblemReportAttachmentResponse409 = {
  data: Problem
  status: 409
}

export type downloadOwnProblemReportAttachmentResponse422 = {
  data: Problem
  status: 422
}

export type downloadOwnProblemReportAttachmentResponse429 = {
  data: Problem
  status: 429
}

export type downloadOwnProblemReportAttachmentResponse503 = {
  data: Problem
  status: 503
}

export type downloadOwnProblemReportAttachmentResponseSuccess = (downloadOwnProblemReportAttachmentResponse200) & {
  headers: Headers;
};
export type downloadOwnProblemReportAttachmentResponseError = (downloadOwnProblemReportAttachmentResponse401 | downloadOwnProblemReportAttachmentResponse403 | downloadOwnProblemReportAttachmentResponse404 | downloadOwnProblemReportAttachmentResponse409 | downloadOwnProblemReportAttachmentResponse422 | downloadOwnProblemReportAttachmentResponse429 | downloadOwnProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type downloadOwnProblemReportAttachmentResponse = (downloadOwnProblemReportAttachmentResponseSuccess | downloadOwnProblemReportAttachmentResponseError)

export const getDownloadOwnProblemReportAttachmentUrl = (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports/${id}/attachments/${fileId}/download?${stringifiedParams}` : `/api/v1/problem-reports/${id}/attachments/${fileId}/download`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Audit and issue a private 60-second original or thumbnail URL.
 */
export const downloadOwnProblemReportAttachment = async (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: RequestInit): Promise<downloadOwnProblemReportAttachmentResponse> => {

  return orvalClient<downloadOwnProblemReportAttachmentResponse>(getDownloadOwnProblemReportAttachmentUrl(id,fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadOwnProblemReportAttachmentQueryKey = (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams,) => {
    return [
    `/api/v1/problem-reports/${id}/attachments/${fileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadOwnProblemReportAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = Problem>(id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadOwnProblemReportAttachmentQueryKey(id,fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>> = ({ signal }) => downloadOwnProblemReportAttachment(id,fileId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadOwnProblemReportAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>>
export type DownloadOwnProblemReportAttachmentQueryError = Problem


export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params: undefined |  DownloadOwnProblemReportAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit and issue a private 60-second original or thumbnail URL.
 */

export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadOwnProblemReportAttachmentQueryOptions(id,fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminProblemReportsResponse200 = {
  data: ProblemReportAdminPage
  status: 200
}

export type listAdminProblemReportsResponse401 = {
  data: Problem
  status: 401
}

export type listAdminProblemReportsResponse403 = {
  data: Problem
  status: 403
}

export type listAdminProblemReportsResponse404 = {
  data: Problem
  status: 404
}

export type listAdminProblemReportsResponse409 = {
  data: Problem
  status: 409
}

export type listAdminProblemReportsResponse422 = {
  data: Problem
  status: 422
}

export type listAdminProblemReportsResponse429 = {
  data: Problem
  status: 429
}

export type listAdminProblemReportsResponse503 = {
  data: Problem
  status: 503
}

export type listAdminProblemReportsResponseSuccess = (listAdminProblemReportsResponse200) & {
  headers: Headers;
};
export type listAdminProblemReportsResponseError = (listAdminProblemReportsResponse401 | listAdminProblemReportsResponse403 | listAdminProblemReportsResponse404 | listAdminProblemReportsResponse409 | listAdminProblemReportsResponse422 | listAdminProblemReportsResponse429 | listAdminProblemReportsResponse503) & {
  headers: Headers;
};

export type listAdminProblemReportsResponse = (listAdminProblemReportsResponseSuccess | listAdminProblemReportsResponseError)

export const getListAdminProblemReportsUrl = (params?: ListAdminProblemReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports?${stringifiedParams}` : `/api/v1/admin/problem-reports`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Capability-gated private report queue.
 */
export const listAdminProblemReports = async (params?: ListAdminProblemReportsParams, options?: RequestInit): Promise<listAdminProblemReportsResponse> => {

  return orvalClient<listAdminProblemReportsResponse>(getListAdminProblemReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminProblemReportsQueryKey = (params?: ListAdminProblemReportsParams,) => {
    return [
    `/api/v1/admin/problem-reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminProblemReportsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = Problem>(params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminProblemReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminProblemReports>>> = ({ signal }) => listAdminProblemReports(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminProblemReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminProblemReports>>>
export type ListAdminProblemReportsQueryError = Problem


export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = Problem>(
 params: undefined |  ListAdminProblemReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listAdminProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = Problem>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listAdminProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = Problem>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Capability-gated private report queue.
 */

export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = Problem>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminProblemReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminProblemReportResponse200 = {
  data: ProblemReportAdminRead
  status: 200
}

export type getAdminProblemReportResponse401 = {
  data: Problem
  status: 401
}

export type getAdminProblemReportResponse403 = {
  data: Problem
  status: 403
}

export type getAdminProblemReportResponse404 = {
  data: Problem
  status: 404
}

export type getAdminProblemReportResponse409 = {
  data: Problem
  status: 409
}

export type getAdminProblemReportResponse422 = {
  data: Problem
  status: 422
}

export type getAdminProblemReportResponse429 = {
  data: Problem
  status: 429
}

export type getAdminProblemReportResponse503 = {
  data: Problem
  status: 503
}

export type getAdminProblemReportResponseSuccess = (getAdminProblemReportResponse200) & {
  headers: Headers;
};
export type getAdminProblemReportResponseError = (getAdminProblemReportResponse401 | getAdminProblemReportResponse403 | getAdminProblemReportResponse404 | getAdminProblemReportResponse409 | getAdminProblemReportResponse422 | getAdminProblemReportResponse429 | getAdminProblemReportResponse503) & {
  headers: Headers;
};

export type getAdminProblemReportResponse = (getAdminProblemReportResponseSuccess | getAdminProblemReportResponseError)

export const getGetAdminProblemReportUrl = (id: string,) => {




  return `/api/v1/admin/problem-reports/${id}`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Capability-gated diagnostic review and full event projection.
 */
export const getAdminProblemReport = async (id: string, options?: RequestInit): Promise<getAdminProblemReportResponse> => {

  return orvalClient<getAdminProblemReportResponse>(getGetAdminProblemReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminProblemReportQueryKey = (id: string,) => {
    return [
    `/api/v1/admin/problem-reports/${id}`
    ] as const;
    }


export const getGetAdminProblemReportQueryOptions = <TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = Problem>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminProblemReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminProblemReport>>> = ({ signal }) => getAdminProblemReport(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminProblemReportQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminProblemReport>>>
export type GetAdminProblemReportQueryError = Problem


export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = Problem>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Capability-gated diagnostic review and full event projection.
 */

export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = Problem>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminProblemReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type commandAdminProblemReportResponse200 = {
  data: ProblemReportCommandReceipt
  status: 200
}

export type commandAdminProblemReportResponse401 = {
  data: Problem
  status: 401
}

export type commandAdminProblemReportResponse403 = {
  data: Problem
  status: 403
}

export type commandAdminProblemReportResponse404 = {
  data: Problem
  status: 404
}

export type commandAdminProblemReportResponse409 = {
  data: Problem
  status: 409
}

export type commandAdminProblemReportResponse422 = {
  data: Problem
  status: 422
}

export type commandAdminProblemReportResponse429 = {
  data: Problem
  status: 429
}

export type commandAdminProblemReportResponse503 = {
  data: Problem
  status: 503
}

export type commandAdminProblemReportResponseSuccess = (commandAdminProblemReportResponse200) & {
  headers: Headers;
};
export type commandAdminProblemReportResponseError = (commandAdminProblemReportResponse401 | commandAdminProblemReportResponse403 | commandAdminProblemReportResponse404 | commandAdminProblemReportResponse409 | commandAdminProblemReportResponse422 | commandAdminProblemReportResponse429 | commandAdminProblemReportResponse503) & {
  headers: Headers;
};

export type commandAdminProblemReportResponse = (commandAdminProblemReportResponseSuccess | commandAdminProblemReportResponseError)

export const getCommandAdminProblemReportUrl = (id: string,) => {




  return `/api/v1/admin/problem-reports/${id}/commands`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Assignment or lifecycle command with expected revision and receipt.
 */
export const commandAdminProblemReport = async (id: string,
    problemReportCommand: ProblemReportCommand, options?: RequestInit): Promise<commandAdminProblemReportResponse> => {

  return orvalClient<commandAdminProblemReportResponse>(getCommandAdminProblemReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportCommand)
  }
);}




export const getCommandAdminProblemReportMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext> => {

const mutationKey = ['commandAdminProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commandAdminProblemReport>>, {id: string;data: ProblemReportCommand}> = (props) => {
          const {id,data} = props ?? {};

          return  commandAdminProblemReport(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommandAdminProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof commandAdminProblemReport>>>
    export type CommandAdminProblemReportMutationBody = ProblemReportCommand
    export type CommandAdminProblemReportMutationError = Problem

    /**
 * @summary Assignment or lifecycle command with expected revision and receipt.
 */
export const useCommandAdminProblemReport = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commandAdminProblemReport>>,
        TError,
        {id: string;data: ProblemReportCommand},
        TContext
      > => {
      return useMutation(getCommandAdminProblemReportMutationOptions(options), queryClient);
    }
    export type downloadAdminProblemReportAttachmentResponse200 = {
  data: ProblemReportDownloadGrant
  status: 200
}

export type downloadAdminProblemReportAttachmentResponse401 = {
  data: Problem
  status: 401
}

export type downloadAdminProblemReportAttachmentResponse403 = {
  data: Problem
  status: 403
}

export type downloadAdminProblemReportAttachmentResponse404 = {
  data: Problem
  status: 404
}

export type downloadAdminProblemReportAttachmentResponse409 = {
  data: Problem
  status: 409
}

export type downloadAdminProblemReportAttachmentResponse422 = {
  data: Problem
  status: 422
}

export type downloadAdminProblemReportAttachmentResponse429 = {
  data: Problem
  status: 429
}

export type downloadAdminProblemReportAttachmentResponse503 = {
  data: Problem
  status: 503
}

export type downloadAdminProblemReportAttachmentResponseSuccess = (downloadAdminProblemReportAttachmentResponse200) & {
  headers: Headers;
};
export type downloadAdminProblemReportAttachmentResponseError = (downloadAdminProblemReportAttachmentResponse401 | downloadAdminProblemReportAttachmentResponse403 | downloadAdminProblemReportAttachmentResponse404 | downloadAdminProblemReportAttachmentResponse409 | downloadAdminProblemReportAttachmentResponse422 | downloadAdminProblemReportAttachmentResponse429 | downloadAdminProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type downloadAdminProblemReportAttachmentResponse = (downloadAdminProblemReportAttachmentResponseSuccess | downloadAdminProblemReportAttachmentResponseError)

export const getDownloadAdminProblemReportAttachmentUrl = (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download?${stringifiedParams}` : `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Review capability and audit before private 60-second URL.
 */
export const downloadAdminProblemReportAttachment = async (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: RequestInit): Promise<downloadAdminProblemReportAttachmentResponse> => {

  return orvalClient<downloadAdminProblemReportAttachmentResponse>(getDownloadAdminProblemReportAttachmentUrl(id,fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadAdminProblemReportAttachmentQueryKey = (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams,) => {
    return [
    `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadAdminProblemReportAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = Problem>(id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAdminProblemReportAttachmentQueryKey(id,fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>> = ({ signal }) => downloadAdminProblemReportAttachment(id,fileId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadAdminProblemReportAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>>
export type DownloadAdminProblemReportAttachmentQueryError = Problem


export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params: undefined |  DownloadAdminProblemReportAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Review capability and audit before private 60-second URL.
 */

export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = Problem>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadAdminProblemReportAttachmentQueryOptions(id,fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getProblemReportCapabilitiesResponse200 = {
  data: ProblemReportCapabilities
  status: 200
}

export type getProblemReportCapabilitiesResponse401 = {
  data: Problem
  status: 401
}

export type getProblemReportCapabilitiesResponse403 = {
  data: Problem
  status: 403
}

export type getProblemReportCapabilitiesResponse404 = {
  data: Problem
  status: 404
}

export type getProblemReportCapabilitiesResponse409 = {
  data: Problem
  status: 409
}

export type getProblemReportCapabilitiesResponse422 = {
  data: Problem
  status: 422
}

export type getProblemReportCapabilitiesResponse429 = {
  data: Problem
  status: 429
}

export type getProblemReportCapabilitiesResponse503 = {
  data: Problem
  status: 503
}

export type getProblemReportCapabilitiesResponseSuccess = (getProblemReportCapabilitiesResponse200) & {
  headers: Headers;
};
export type getProblemReportCapabilitiesResponseError = (getProblemReportCapabilitiesResponse401 | getProblemReportCapabilitiesResponse403 | getProblemReportCapabilitiesResponse404 | getProblemReportCapabilitiesResponse409 | getProblemReportCapabilitiesResponse422 | getProblemReportCapabilitiesResponse429 | getProblemReportCapabilitiesResponse503) & {
  headers: Headers;
};

export type getProblemReportCapabilitiesResponse = (getProblemReportCapabilitiesResponseSuccess | getProblemReportCapabilitiesResponseError)

export const getGetProblemReportCapabilitiesUrl = () => {




  return `/api/v1/problem-reports/capabilities`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Read current effective reporting availability and action capabilities. Historical reads remain available when disabled.
 */
export const getProblemReportCapabilities = async ( options?: RequestInit): Promise<getProblemReportCapabilitiesResponse> => {

  return orvalClient<getProblemReportCapabilitiesResponse>(getGetProblemReportCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProblemReportCapabilitiesQueryKey = () => {
    return [
    `/api/v1/problem-reports/capabilities`
    ] as const;
    }


export const getGetProblemReportCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProblemReportCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProblemReportCapabilities>>> = ({ signal }) => getProblemReportCapabilities({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProblemReportCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProblemReportCapabilities>>>
export type GetProblemReportCapabilitiesQueryError = Problem


export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProblemReportCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getProblemReportCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProblemReportCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getProblemReportCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read current effective reporting availability and action capabilities. Historical reads remain available when disabled.
 */

export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProblemReportCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listProblemReportAssigneesResponse200 = {
  data: ProblemReportAssigneePage
  status: 200
}

export type listProblemReportAssigneesResponse401 = {
  data: Problem
  status: 401
}

export type listProblemReportAssigneesResponse403 = {
  data: Problem
  status: 403
}

export type listProblemReportAssigneesResponse404 = {
  data: Problem
  status: 404
}

export type listProblemReportAssigneesResponse409 = {
  data: Problem
  status: 409
}

export type listProblemReportAssigneesResponse422 = {
  data: Problem
  status: 422
}

export type listProblemReportAssigneesResponse429 = {
  data: Problem
  status: 429
}

export type listProblemReportAssigneesResponse503 = {
  data: Problem
  status: 503
}

export type listProblemReportAssigneesResponseSuccess = (listProblemReportAssigneesResponse200) & {
  headers: Headers;
};
export type listProblemReportAssigneesResponseError = (listProblemReportAssigneesResponse401 | listProblemReportAssigneesResponse403 | listProblemReportAssigneesResponse404 | listProblemReportAssigneesResponse409 | listProblemReportAssigneesResponse422 | listProblemReportAssigneesResponse429 | listProblemReportAssigneesResponse503) & {
  headers: Headers;
};

export type listProblemReportAssigneesResponse = (listProblemReportAssigneesResponseSuccess | listProblemReportAssigneesResponseError)

export const getListProblemReportAssigneesUrl = (params?: ListProblemReportAssigneesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports/assignees?${stringifiedParams}` : `/api/v1/admin/problem-reports/assignees`
}

/**
 * Requires canonical membership context. Any X-Act-As-Org is rejected with 403 report_view_as_not_supported.
 * @summary Review AND manage required. Current eligible canonical Admin memberships only; scalar identity labels, ascending UUID cursor. Default 25, maximum 100. Pagination bounds scanned canonical candidates; revoked candidates are omitted, so a page may be sparse or empty while has_more is true.
 */
export const listProblemReportAssignees = async (params?: ListProblemReportAssigneesParams, options?: RequestInit): Promise<listProblemReportAssigneesResponse> => {

  return orvalClient<listProblemReportAssigneesResponse>(getListProblemReportAssigneesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProblemReportAssigneesQueryKey = (params?: ListProblemReportAssigneesParams,) => {
    return [
    `/api/v1/admin/problem-reports/assignees`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProblemReportAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = Problem>(params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProblemReportAssigneesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProblemReportAssignees>>> = ({ signal }) => listProblemReportAssignees(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProblemReportAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listProblemReportAssignees>>>
export type ListProblemReportAssigneesQueryError = Problem


export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = Problem>(
 params: undefined |  ListProblemReportAssigneesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportAssignees>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = Problem>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportAssignees>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = Problem>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Review AND manage required. Current eligible canonical Admin memberships only; scalar identity labels, ascending UUID cursor. Default 25, maximum 100. Pagination bounds scanned canonical candidates; revoked candidates are omitted, so a page may be sparse or empty while has_more is true.
 */

export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = Problem>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProblemReportAssigneesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listProblemReportNotificationsResponse200 = {
  data: ProblemReportNotificationPage
  status: 200
}

export type listProblemReportNotificationsResponse401 = {
  data: Problem
  status: 401
}

export type listProblemReportNotificationsResponse403 = {
  data: Problem
  status: 403
}

export type listProblemReportNotificationsResponse404 = {
  data: Problem
  status: 404
}

export type listProblemReportNotificationsResponse409 = {
  data: Problem
  status: 409
}

export type listProblemReportNotificationsResponse422 = {
  data: Problem
  status: 422
}

export type listProblemReportNotificationsResponse429 = {
  data: Problem
  status: 429
}

export type listProblemReportNotificationsResponse500 = {
  data: Problem
  status: 500
}

export type listProblemReportNotificationsResponse503 = {
  data: Problem
  status: 503
}

export type listProblemReportNotificationsResponseSuccess = (listProblemReportNotificationsResponse200) & {
  headers: Headers;
};
export type listProblemReportNotificationsResponseError = (listProblemReportNotificationsResponse401 | listProblemReportNotificationsResponse403 | listProblemReportNotificationsResponse404 | listProblemReportNotificationsResponse409 | listProblemReportNotificationsResponse422 | listProblemReportNotificationsResponse429 | listProblemReportNotificationsResponse500 | listProblemReportNotificationsResponse503) & {
  headers: Headers;
};

export type listProblemReportNotificationsResponse = (listProblemReportNotificationsResponseSuccess | listProblemReportNotificationsResponseError)

export const getListProblemReportNotificationsUrl = (params?: ListProblemReportNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports/notifications?${stringifiedParams}` : `/api/v1/problem-reports/notifications`
}

/**
 * Private/no-store; canonical context required, view-as forbidden. History remains available when reporting is disabled. No generic notifications capability required. User-wide neutral history contains no report or organization metadata.
 * @summary Read only current recipient neutral report notifications.
 */
export const listProblemReportNotifications = async (params?: ListProblemReportNotificationsParams, options?: RequestInit): Promise<listProblemReportNotificationsResponse> => {

  return orvalClient<listProblemReportNotificationsResponse>(getListProblemReportNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProblemReportNotificationsQueryKey = (params?: ListProblemReportNotificationsParams,) => {
    return [
    `/api/v1/problem-reports/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProblemReportNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = Problem>(params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProblemReportNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProblemReportNotifications>>> = ({ signal }) => listProblemReportNotifications(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProblemReportNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listProblemReportNotifications>>>
export type ListProblemReportNotificationsQueryError = Problem


export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = Problem>(
 params: undefined |  ListProblemReportNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportNotifications>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = Problem>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportNotifications>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = Problem>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read only current recipient neutral report notifications.
 */

export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = Problem>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProblemReportNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getOwnProblemReportNotificationTargetResponse200 = {
  data: ProblemReportNotificationTarget
  status: 200
}

export type getOwnProblemReportNotificationTargetResponse401 = {
  data: Problem
  status: 401
}

export type getOwnProblemReportNotificationTargetResponse403 = {
  data: Problem
  status: 403
}

export type getOwnProblemReportNotificationTargetResponse404 = {
  data: Problem
  status: 404
}

export type getOwnProblemReportNotificationTargetResponse409 = {
  data: Problem
  status: 409
}

export type getOwnProblemReportNotificationTargetResponse422 = {
  data: Problem
  status: 422
}

export type getOwnProblemReportNotificationTargetResponse429 = {
  data: Problem
  status: 429
}

export type getOwnProblemReportNotificationTargetResponse500 = {
  data: Problem
  status: 500
}

export type getOwnProblemReportNotificationTargetResponse503 = {
  data: Problem
  status: 503
}

export type getOwnProblemReportNotificationTargetResponseSuccess = (getOwnProblemReportNotificationTargetResponse200) & {
  headers: Headers;
};
export type getOwnProblemReportNotificationTargetResponseError = (getOwnProblemReportNotificationTargetResponse401 | getOwnProblemReportNotificationTargetResponse403 | getOwnProblemReportNotificationTargetResponse404 | getOwnProblemReportNotificationTargetResponse409 | getOwnProblemReportNotificationTargetResponse422 | getOwnProblemReportNotificationTargetResponse429 | getOwnProblemReportNotificationTargetResponse500 | getOwnProblemReportNotificationTargetResponse503) & {
  headers: Headers;
};

export type getOwnProblemReportNotificationTargetResponse = (getOwnProblemReportNotificationTargetResponseSuccess | getOwnProblemReportNotificationTargetResponseError)

export const getGetOwnProblemReportNotificationTargetUrl = (notificationId: string,) => {




  return `/api/v1/problem-reports/notifications/${notificationId}/target`
}

/**
 * Private/no-store; canonical context required, view-as forbidden. History remains available when reporting is disabled. No generic notifications capability required. Own scope always requires current user and organization; admin scope requires current review authority. Missing, hidden or mismatched targets return the same safe 404.
 * @summary Resolve current recipient notification to an independently authorized own report target.
 */
export const getOwnProblemReportNotificationTarget = async (notificationId: string, options?: RequestInit): Promise<getOwnProblemReportNotificationTargetResponse> => {

  return orvalClient<getOwnProblemReportNotificationTargetResponse>(getGetOwnProblemReportNotificationTargetUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnProblemReportNotificationTargetQueryKey = (notificationId: string,) => {
    return [
    `/api/v1/problem-reports/notifications/${notificationId}/target`
    ] as const;
    }


export const getGetOwnProblemReportNotificationTargetQueryOptions = <TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = Problem>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnProblemReportNotificationTargetQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>> = ({ signal }) => getOwnProblemReportNotificationTarget(notificationId, { signal });





   return  { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnProblemReportNotificationTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>>
export type GetOwnProblemReportNotificationTargetQueryError = Problem


export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve current recipient notification to an independently authorized own report target.
 */

export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = Problem>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnProblemReportNotificationTargetQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






